// extracted by mini-css-extract-plugin
export default {"accountDeletionBlock":"style_accountDeletionBlock__LgMiK","becomeRealtorForm":"style_becomeRealtorForm__87RCx","errorText":"style_errorText__ctJhH"};